<template>
  <div>
    <Pane/>

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-input v-model="form.name" placeholder="商品名称"/>
            </a-form-model-item>


            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-space>
                <a-button
                    v-if="$getPermission($route.path + '/add')"
                    @click="$router.push($route.path + '/add')"
                    type="primary"
                >新建
                </a-button>
<!--                <a-button-->
<!--                    v-if="$getPermission($route.path + '/office-apply')"-->
<!--                    @click="showApply"-->
<!--                    type="primary"-->
<!--                >采购申请-->
<!--                </a-button>-->
<!--                <a-button-->
<!--                    v-if="$getPermission($route.path + '/office-apply')"-->
<!--                    @click="showRecord"-->
<!--                >采购记录-->
<!--                </a-button>-->
              </a-space>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding/>

      <a-table
          bordered
          :dataSource="list"
          :loading="loading"
          @change="onChange"
          :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="商品名称" data-index="name"></a-table-column>
        <a-table-column title="规格型号" data-index="spec"></a-table-column>
        <a-table-column title="颜色" data-index="color"></a-table-column>

        <a-table-column title="单位" data-index="unit" align="center">
        </a-table-column>
        <a-table-column title="单价" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.price }}</span>
          </template>
        </a-table-column>
        <a-table-column title="备注" data-index="remark"></a-table-column>
        <a-table-column title="分类" data-index="category"></a-table-column>
        <a-table-column title="操作" align="right" width="120px">
          <template slot-scope="text">
            <a-space>
              <!-- <Adjust
                :text="text"
                @refresh="refresh"
                v-if="$getPermission($route.path + '/adjust')"
              /> -->
              <a
                  href="#"
                  @click="editText(text)"
                  v-if="$getPermission($route.path + '/edit')"
              >编辑</a
              >
              <a
                  href="#"
                  @click="deleteText(text)"
                  style="color: #f5222d"
                  v-if="$getPermission($route.path + '/edit')"
              >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>

    <!-- 采购申请弹窗 -->
    <a-modal
        :visible="applyVisible"
        title="采购申请"
        :footer="null"
        :maskClosable="false"
        width="70%"
        @cancel="applyVisible = false"
    >
      <OfficeApply
          v-if="applyVisible"
          :inModal="true"
          @close="applyVisible = false"
          @success="getList"
      />
    </a-modal>

    <!-- 采购记录弹窗 -->
    <a-modal
        :visible="recordVisible"
        title="采购记录"
        :footer="null"
        width="70%"
        @cancel="recordVisible = false"
    >
      <OfficeRecord
          v-if="recordVisible"
          :inModal="true"
          @close="recordVisible = false"
          @detail="showDetail"
      />
    </a-modal>

    <!-- 采购详情弹窗 -->
    <a-modal
        :visible="detailVisible"
        title="采购详情"
        :footer="null"
        width="70%"
        @cancel="detailVisible = false"
    >
      <OfficeApply
          v-if="detailVisible"
          :inModal="true"
          :detailData="detailRecord"
          @close="detailVisible = false"
      />
    </a-modal>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import {fetchList, deleteCategory} from "@/api/oa/purchaseMaterials";
import {mapGetters} from "vuex";
import Adjust from "./components/adjust.vue";
import OfficeApply from "./office-apply.vue";
import OfficeRecord from "./office-record.vue";

export default {
  mixins: [watermark],

  components: {
    Adjust,
    OfficeApply,
    OfficeRecord,
  },

  data() {
    return {
      form: {},
      subTypeList: [],

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,

      applyVisible: false,
      recordVisible: false,
      detailVisible: false,
      detailRecord: null,
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("giftType");
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    deleteText(text) {
      this.$confirm({
        title: "删除确认",
        content: `确认删除 "${text.name}" 吗？`,
        onOk: () => {
          deleteCategory(text.id)
              .then(() => {
                this.getList();
              })
              .catch(() => {
                this.$message.error("删除失败");
              });
        },
      });
    },
    getList() {
      const {current, pageSize, form} = this;

      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize,
        ...form,
      })
          .then((res) => {
            this.loading = false;
            if (Array.isArray(res.list)) {
              this.list = res.list;
              this.total = res.totalSize;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },

    refresh() {
      this.getList();
    },

    editText(text) {
      window.localStorage.setItem("edit-material", JSON.stringify(text));
      this.$router.push(this.$route.path + `/edit`);
    },

    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    onTypeChange(value) {
      if (value) {
        const obj = this.typeList.find((item) => item.value === value);
        if (obj && Array.isArray(obj.children)) {
          this.subTypeList = obj.children;
        }
      } else {
        this.subTypeList = [];
      }
    },

    showApply() {
      this.applyVisible = true;
    },
    showRecord() {
      this.recordVisible = true;
    },
    showDetail(record) {
      this.detailRecord = record;
      this.detailVisible = true;
    },
  },
};
</script>